<template lang="html">
  <article class="media">
    <div class="media-content">
      <div class="content">
        <p>
<strong>Past lives:</strong> Sound engineer, horse trainer, sailing captain/instructor.
        </p>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "past"
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/jobs/Past.vue